export default [
  {
    path: "/",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "home",
        path: "",
        component: () => import("@/modules/strategic_plans/pages/PublicList"),
        meta: {
          title: "Planos Municipais",
          breadcrumbs: [],
          permission: "strategic_plan:view"
        }
      }
    ]
  }
];
